import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { RichText } from 'prismic-reactjs'
import dayjs from 'dayjs'
import styles from './LegalDoc.module.scss'
import htmlSerializer from '../../utils/htmlSerializer'

const LegalDoc = ({ doc }) => {
  const date = dayjs(doc.updated_date).format('MMMM D, YYYY')

  return (
    <div className={cx(styles.container, 'container')}>
      <div className='content'>
        <h5>Last Updated: {date}</h5>
        <div className='title'>{RichText.render(doc.title)}</div>
        <div className='legal-body'>
          <RichText render={doc.body} htmlSerializer={htmlSerializer} />
        </div>
      </div>
    </div>
  )
}

LegalDoc.propTypes = {
  doc: PropTypes.object
}

export default LegalDoc
